import { useEffect } from "react";
import styled from "styled-components";
import ScrollAnimation from "react-animate-on-scroll";
import { Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";

import { scrollAnimationProps as animationProps } from "globalConstants";

import * as Types from "Types";

import * as images from "images";

const Wrap = styled.div<Types.Default>`
   width: 100%;
   margin-top: 55px;
   padding: 120px 0 200px 0;
   background-color: #f2f8fc;

   & .animated {
      transition-duration: 1s;
      transition-property: opacity;
      transition-timing-function: ease-in-out;
      opacity: 0;
   }
   & .scrollAnimation {
      opacity: 1;
   }
   ${({ css }) => css}
`;

const Container = styled.div<Types.Default>`
   width: 100%;
   max-width: 1200px;
   margin: 0 auto;
`;
const Title = styled.h2`
   text-align: center;

   & img {
      height: 31px;
   }
`;

const Link = styled.a`
   width: 364px;
   height: 232px;

   @media screen and (max-width: 500px) {
      width: 364px;
      height: 232px;
   }
   display: block;
   background-position: center center;
   background-repeat: no-repeat;
   background-size: cover;
   box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
`;

const Gap = styled.div`
   margin-top: 110px;
   @media screen and (max-width: 500px) {
      margin-top: 50px;
   }
`;

const LinkTitle = styled.div`
   margin-top: 10px;
   display: flex;
   flex-direction: row;
   align-items: center;
   gap: 10px;
   color: #838383;
   font-weight: 400;
   font-size: 18px;
   line-height: 31px;
   width: 364px;
   &:before {
      content: "";
      display: inline-block;
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background-color: #838383;
   }
   & span {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      width: 349px;
   }
`;

const ar = [
   {
      img: images.slide2020,
      src: "//www.seouland.com/arti/culture/culture_general/6191.html",
      backgroundPosition: "right bottom",
      title: "주변에서 미술 작품 찾기",
   },
   {
      img: images.slide20190_1,
      src: "https://www.arko.or.kr/board/view/772?bid=&cid=1602504&sf_icon_category=",
      backgroundPosition: "center center",
      title: "지금 아르코에서는",
   },
   {
      img: images.slide20190_2,
      src: "https://www.mk.co.kr/news/culture/view/2019/08/627848/",
      backgroundPosition: "center center",
      title: "취향 저격 애플리케이션-휴대전화 속 미술관 나들이 아트맵",
   },
   {
      img: images.slide2018,
      src: "https://m.blog.naver.com/jump_arko/221325431208",
      backgroundPosition: "center center",
      title: "[인터뷰] 당신에게 미술관을 배달합니다. 데이터 기반의 미술 큐레이션 서비스, 아트맵 김선영 대표",
   },
   {
      img: images.slide2016,
      src: "//news.donga.com/3/all/20161129/81589402/1",
      backgroundPosition: "center center",
      title: "[청년드림/내가 청년 리더]‘맞춤형 미술관’ 배달해 드립니다",
   },
];
export default function SectionPress(props: Types.Default) {
   return (
      <Wrap {...props}>
         <Container>
            <ScrollAnimation {...animationProps}>
               <Title>
                  <img src={images.pressTitle} alt="" />
               </Title>
            </ScrollAnimation>
            <Gap></Gap>
            <ScrollAnimation {...animationProps}>
               <Swiper slidesPerView={"auto"} spaceBetween={20} autoplay={true} modules={[Autoplay]}>
                  {ar.map((row, index) => (
                     <SwiperSlide key={index} style={{ width: "fit-content" }}>
                        <Link target="_blank" href={row.src} style={{ backgroundImage: `url("${row.img}")`, backgroundPosition: row.backgroundPosition }}></Link>
                        <LinkTitle>
                           <span>{row.title}</span>
                        </LinkTitle>
                     </SwiperSlide>
                  ))}
               </Swiper>
            </ScrollAnimation>
         </Container>
      </Wrap>
   );
}
